"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//import { fetchRequest, fetchRequestWithBodyHeader } from '../requestUtil';
const requestUtil_1 = require("../requestUtil");
const configurations_1 = require("../configurations");
const getSecurityPolicy = (code) => {
    const url = `${(0, configurations_1.getServer)().SYSTEM_PARAMETER + configurations_1.PATH.GET_SECURITY_POLICY}?code=${code}`;
    return (0, requestUtil_1.fetchRequest)(url, 'GET', {}, null, true);
};
exports.default = getSecurityPolicy;
